type PartialWindow = Pick<Window, 'navigator' | 'ontouchstart'>;

export function isTouch(partOfWindow: PartialWindow): boolean {
	const maxTouchPoints = partOfWindow.navigator.maxTouchPoints;

	return 'ontouchstart' in partOfWindow || maxTouchPoints > 0;
}
